<template>
  <div>
    <div class="topbar">
      <div class="clearfix main-wrap">
        <a class="pull-left img-back" href="javascript:window.history.go(-1)">返回</a>
        <h1>{{ curche.info.curcheName }}</h1>
        <router-link class="pull-right icon-right orange" :to="{path:'/curche/edit'}" v-if="cookie_login_data.jobId == 1 || cookie_login_data.jobId == 2" tag="span">设置</router-link>
      </div>
      <div class="liner"></div>
    </div>


    <mt-loadmore :top-method="loadTop" ref="loadmore">
    <div class="main-page">
      <div class="swiper-container banner curche">
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="item in curche.info.curcheImageList"><img :src="item.baseAcessPath + item.imageAddress" /></div>
        </div>
        <!-- 如果需要分页器 -->
        <div class="swiper-pagination"></div>
      </div>
      <ul class="list-group-item" style="margin-top:0">
        <li class="list-group" style="padding:15px 0 15px 15px">
          <p class="font-16 strong">{{ curche.info.curcheName }}</p>
          <p>电话：{{ curche.info.field1 }}</p>
          <p v-if="curche.info.areaName">城市：{{ curche.info.provinceName }} {{ curche.info.cityName }} {{ curche.info.areaName }}</p>
          <p>地址：{{ curche.info.curcherAddress }}</p>
          <p>学校：{{ curche.info.serviceSchool }}</p>
        </li>
        <li class="list-group hide">
          <div class="liner"></div>
         <a href="#" class="block text-center font-12 padding-15 gray">有疑问？点这里</a>
        </li>
        <li class="list-group">
          <div class="liner"></div>
          <div class="padding-15">
            <p class="font-16 strong">园点师资</p>
            <ul class="clearfix teacher-show text-center">
              <li v-for="item in curche.info.curcheTeacher">
                <div class="img-wrap small"><img :src="item.teacherIcon ? (item.baseAcessPath + item.teacherIcon) : img_default" width="100%"/></div>
                <span>{{ item.teacherName }}</span>
              </li>
            </ul>
          </div>
        </li>
      </ul>
      <ul class="pill-group clearfix padding-15">
        <li class="pill-block primary" v-for="item in curche.info.curcheServiceList">{{ item.serviceName }}：{{ item.nextServiceFee }}元/月</li>
      </ul>
    </div>
    </mt-loadmore>
  </div>
</template>
<script>
import { service } from '../../service'
import { mapGetters, mapMutations } from 'vuex'

export default {
  computed: mapGetters({
    curche: 'curche'
  }),
  data () {
    return {
      img_default: require('../../assets/images/img-default.png'),
      login_data: JSON.parse(window.localStorage['login_data']),
      cookie_login_data: JSON.parse(window.localStorage['basic_login_data']),
      get_curche_info_msg_para: service.setPara('getCurcheInfo'),
      curcheId: 0,
      mySwiper: {}
    }
  },
  created () {
    this.setPara()
  },
  mounted: function () {
    this.setPara()
    this.getCurcheInfoMsg()
  },
  methods: {
    ...mapMutations([
      'clearCurche',
      'receiveCurche'
    ]),
    loadTop (id) {
      this.$store.dispatch('clearCurche')
      if (this.mySwiper.destroy) {
        this.mySwiper.destroy(false, true)
      }

      this.getCurcheInfoMsg()
      this.$refs.loadmore.onTopLoaded(id)
    },
    setPara: function () {
      this.get_curche_info_msg_para.curcheId = this.cookie_login_data.curcheId
      this.get_curche_info_msg_para.context = this
    },
    getCurcheInfoMsg: function () {
      // this.receiveCurche(this.get_curche_info_msg_para)
      if (!this.curche.flag) {
        var that = this
        this.get_curche_info_msg_para.callback = () => {
          that.$nextTick(function () {
            that.mySwiper = new Swiper('.swiper-container', {
              loop: true,
              // 如果需要分页器
              pagination: '.swiper-pagination',
              autoplay: 2500,
              autoplayDisableOnInteraction: false
            })
          })
        }
        this.$store.dispatch('receiveCurche', this.get_curche_info_msg_para)
      } else {
        this.$nextTick(function () {
          this.mySwiper = new Swiper('.swiper-container', {
            loop: true,
            // 如果需要分页器
            pagination: '.swiper-pagination',
            autoplay: 2500,
            autoplayDisableOnInteraction: false
          })
        })
      }
    }
  },
  beforeDestroy: function () {
    if (this.mySwiper.destroy) {
      this.mySwiper.destroy(false, true)
    }
  }
}
</script>
<style scoped>
  .swiper-slide{overflow:hidden;}
</style>


// WEBPACK FOOTER //
// CurcheDetail.vue?abc40da2